export default "__VITE_ASSET__zBAwW52___"